import React from 'react';
import { PapiEditorText } from '@wix/da-papi-types';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { UseEditorOptions } from '@wix/da-editor-tiptap/pkg/hooks/useEditor';
import { EditorApi } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import useEditorNg from '@wix/da-shared-react/pkg/DaEditorNg/hooks/useEditorNg';
import { EditorContextProviderWrapper } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import EditorCommon from '@wix/da-shared-react/pkg/DaEditorNg/EditorCommon';
import OriginalsQuestionTiptapEditor from '@wix/da-editor-tiptap/pkg/components/Editor/presets/OriginalsQuestion';

export type EditorTiptapContentReadyHandler = (api: EditorApi) => void;

export interface Props {
  className?: string;
  initialContent?: PapiEditorText;
  placeholder?: string;
  onInitialContentReady?: EditorTiptapContentReadyHandler;
  onChange?: UseEditorOptions['onEditorChange'];
}

const OriginalsQuestionEditor: React.FC<Props> = ({
  onChange,
  onInitialContentReady,
  initialContent,
  placeholder,
}) => {
  const { editorProps, editorSharedProps, editorCommonProps } = useEditorNg({
    onEditorChange: onChange,
    onEditorReady: (api: EditorApi) => {
      onInitialContentReady && onInitialContentReady(api);
    },
  });
  return (
    <EditorContextProviderWrapper>
      <EditorCommon {...editorCommonProps} />
      <OriginalsQuestionTiptapEditor
        cookieType={MeasuredCookieType.EDITOR_ORIGINALS_QUESTION}
        {...editorSharedProps}
        {...editorProps}
        initialContent={initialContent}
        placeholder={placeholder}
      />
    </EditorContextProviderWrapper>
  );
};
OriginalsQuestionEditor.displayName = 'OriginalsQuestionEditor';

export default OriginalsQuestionEditor;
